<template>
  <component :is="resolvedComponent" :message="message" />
</template>

<script>
import TextRenderer from './TextRenderer.vue';

const rendererRegistry = {
  text: TextRenderer
  // future: image: ImageRenderer, chart: ChartRenderer
};

export default {
  name: 'MessageRenderer',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    resolvedComponent() {
      return rendererRegistry[this.message.content_type] || TextRenderer;
    }
  }
};
</script>
